<div class="d-flex justify-content-between align-items-center">
    <div class="card-sub-heading ml-3 bold pay_with_title">Process Order</div>
    <div (click)="continue()">
      <button mat-icon-button [disabled]="isLoading" (click)="this.dialogRef.close()" type="button">
        <img src="assets/images/icons/grey_cross_icon.png" alt="close icon" />
      </button>
    </div>
</div>


<ng-container *ngIf="isResult == 'processOrder'">
  <form [formGroup]="form" (ngSubmit)="onProceedClick()">
    <div class="my-2 text-center">
      <img src="assets/images/random_assets/warning.png" alt="warning icon" />
     
    </div>
    <div class="ml-3 text-center">
     
      <div class="card-sub-heading warning_title">Warning!</div>
      <div class="mt-2 bold px-4" style="color: #e3432a"
        *ngIf="pendingPayments && pendingPayments.length > 0"
      >
        Order ID{{ pendingPayments.length > 1 ? "` s" : "" }}
        {{ waitingForPaymentOrderIds }} has pending amount to be Paid.
      </div>
    </div>
    <div class="border-bottom p-2" *ngIf="emptyUsers.length > 0">
      <div class="d-flex justify-content-between">
        <div>
          <strong>
            Please note that: Email doesn't exist in following orders so it
            cannot be reflected in Rxdash:
          </strong>
        </div>
      </div>
      <div
        class="d-flex justify-content-between px-3"
        *ngFor="let item of emptyUsers"
      >
        <div class="pb-3">
          <strong> Order ID:</strong>
          {{ item.OrderID }} ({{ item.FirstName }} {{ item.LastName }})
        </div>
      </div>
    </div>
    <div>
     <div *ngIf="shippingService.deliveryPartnerName == 'Canada Post'">
      <div class="pt-3 ml-3">
        <strong> Please choose the pickup options for selected orders:</strong>
      </div>
      <form [formGroup]="canadaPostForm">
      <div class="d-flex justify-content-between  p-3">
        <input type="date" class="form-control" placeholder="Pickup Date" formControlName="Date" />
      </div>
      <div class="p-3">
        <!-- <input type="text" class="form-control" placeholder="Pickup Preferred Time"  formControlName="PreferredTime" /> -->
        <!-- <material-timepicker color="primary" label="Hour" formControlName="PreferredTime" (change)="onChangeHour($event)" revertLabel="Remove" submitLabel="Ok"></material-timepicker> -->
        <mat-label>Time</mat-label>
          <input matInput class="form-control" type="time" id="appt" name="appt"  formControlName="PreferredTime"/>
      </div>
      <div class="border-bottom p-3">
        <!-- <input type="text" class="form-control" placeholder="Pickup Closing Time"  formControlName="ClosingTime" /> -->
        <mat-label>Time</mat-label>
          <input matInput class="form-control" type="time" id="appt" name="appt"  formControlName="ClosingTime"/>
      </div>
    </form>
    </div> 
      <div class="d-flex justify-content-between border-bottom p-3">
        <div>Orders Selected</div>
        <div>{{ props.orders.length }}</div>
      </div>
      <div class="d-flex justify-content-between border-bottom p-3">
        <div>Orders With Pending Payment</div>
        <div>{{ pendingPayments.length }}</div>
      </div>
    </div>
    <mat-checkbox
      class="example-margin bold mt-3 ml-3"
      (change)="onCheckChange($event)"
      formControlName="NotifyUsers"
    >
      Notify Users
    </mat-checkbox>
    <div class="row p-3" *ngIf="form.value.NotifyUsers">
      <div class="col-md-12">
        <div class="d-flex row py-3">
          <ng-container formArrayName="NotifyUsersBy">
            <ng-container
              *ngFor="let item of notifyByArray.controls; let i = index"
            >
              <ng-container [formGroupName]="i">
                <div class="col-md-4">
                  <mat-checkbox
                    value="{{ item.value.id }}"
                    [disabled]="item.value.disable"
                    formControlName="isChecked"
                    >{{ item.value.value }}
                  </mat-checkbox>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
          <app-error-message
            [formName]="form"
            [fieldName]="'NotifyUsersBy'"
            [type]="'group'"
          >
          </app-error-message>
        </div>
      </div>
    </div>
    <div class="d-flex mt-3">
      <div class="col-md-12 d-flex justify-content-center">
        <button
          class="custom-btn w-100"
          [disabled]="isLoading"
          (click)="dialogRef.close()"
          type="button"
        >
          Cancel
        </button>
        <button class="custom-btn w-100" type="submit" [disabled]="isLoading">
          Proceed Anyway
          <span class="whiteLoader" *ngIf="isLoading">&nbsp;</span>
        </button>
      </div>
    </div>
  </form>
</ng-container>

<ng-container *ngIf="isResult == 'processedResult'">
  <div class="ml-3 my-3">
    <div class="card-sub-heading">Result!</div>
  </div>
  <ng-container *ngIf="result.successfull > 0">
    <div class="d-flex justify-content-between border-bottom px-3 py-3">
      <div>Orders Processed successfully:</div>
      <div>{{ result.successfull }}</div>
    </div>
  </ng-container>
  <ng-container *ngIf="result.unSuccessfull?.length > 0">
    <div class="d-flex justify-content-between px-3 py-3">
      <div>Unable to process the following orders:</div>
    </div>
    <div
      class="d-flex justify-content-between px-3"
      *ngFor="let item of result.unSuccessfull"
    >
      <div class="pb-3">
        <strong> Order ID:</strong>
        {{ item.OrderID }} ({{ item.ErrorMessage }})
      </div>
    </div>
  </ng-container>
  <div class="d-flex mt-3">
    <div class="col-md-12 d-flex justify-content-center" (click)="continue()">
      <button class="custom-btn w-100" (click)="dialogRef.close()">
        Continue
      </button>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="isResult == 'noDeliverPartner'">
  <div class="ml-3 my-3">
    <div class="card-sub-heading">Result!</div>
  </div>
  <ng-container *ngIf="result.noDeliveryPartner?.length > 0">
    <div class="d-flex justify-content-between px-3 py-3">
      <div>
        Please select delivery partner for the following selected orders to
        proceed:
      </div>
    </div>
    <div
      class="d-flex justify-content-between px-3"
      *ngFor="let item of result.noDeliveryPartner"
    >
      <div class="pb-3">
        <strong> Order ID:</strong>
        {{ item.OrderID }}
      </div>
    </div>
  </ng-container>
  <div class="d-flex mt-3">
    <div class="col-md-12 d-flex justify-content-center">
      <button class="custom-btn w-100" (click)="dialogRef.close()">OK</button>
    </div>
  </div>
</ng-container>
